// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.no-x[data-v-85c7d002] {\n  overflow-x: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
